import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'is-serial-old-used',
    initialState: {
        is_serial_old_used: false,
        statusAction: 'READY',
    },
    actions: ['IS_SN_OLD_USED'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.IS_SN_OLD_USED_SUCCESS:
                return {
                    ...state,
                    is_serial_old_used: action.payload.is_serial_old_used,
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //isSerialOldUsed
        isSerialOldUsedRequest: (sn_old, pk) => ({
            type: types.IS_SN_OLD_USED_REQUEST,
            payload: { sn_old, pk },
        }),
        isSerialOldUsedSuccess: ({ is_serial_old_used }) => ({
            type: types.IS_SN_OLD_USED_SUCCESS,
            payload: { is_serial_old_used },
        }),
        isSerialOldUsedFailed: error => ({ type: types.IS_SN_OLD_USED_FAILED, error: true, payload: { error } }),
    }),
});
